import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageMeta from "../../../components/common/PageMeta";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import Switch from "../../../components/form/switch/Switch";
import Select from "../../../components/form/Select";
import ProductTable from "./ProductTable";
import FilterDropDown from "./FilterDropDown";

const Products = () => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [textFilters, setTextFilters] = useState<{ [key: string]: string }>({});
  const [checkboxFilters, setCheckboxFilters] = useState<{
    [key: string]: "Yes" | "No" | null;
  }>({});

  const handleTextFilterChange = (key: string, value: string) => {
    setTextFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleCheckboxFilterChange = (key: string, value: "Yes" | "No" | null) => {
    setCheckboxFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSelectFilterChange = (key: string, value: string) => {
    setTextFilters((prev) => ({ ...prev, [key]: value }));
  };

  const removeFilter = (filter: string) => {
    setSelectedFilters(selectedFilters.filter((f) => f !== filter));
    setTextFilters((prev) => {
      const newFilters = { ...prev };
      delete newFilters[filter];
      return newFilters;
    });
    setCheckboxFilters((prev) => {
      const newFilters = { ...prev };
      delete newFilters[filter];
      return newFilters;
    });
  };

  const navigate = useNavigate();

  const searchOptions = [
    "Name",
    "Product Type",
    "Venue",
    "Display",
    "Code",
    "Supplier",
    "Category",
    "Sub-Category",
    "Single-item Barcode Number",
    "Packaging Barcode Number",
    "Recipe",
  ];

  const checkboxOptions = [
    "Cooked Product",
    "Star Item",
    "Available for Franchise",
    "Ingredient Name for Labels",
    "Linked to Supplier",
    "Priced Per Kg",
    "GST",
    "Temperature on Delivery",
    "Expiry Tracking",
    "Bulk Ingredient",
    "Yield Monitoring",
    "Include in Central Inventory",
    "Packaging Barcode",
  ];

  const selectOptions: { [key: string]: string[] } = {
    "Product Type": ["Standard", "Core", "Prepared"],
    Venue: ["Brighton Lakes Recreation and Golf Club", "Castle Hill RSL Club", "Cronulla RSL"],
    Supplier: ["AYVA Packaging Pty Ltd", "Asahi", "Azzi Fruits"],
    Category: ["Bakery", "CHQ Bakery", "CHQ Meats", "CHQ Produce", "CHQ Seafood"],
    "Sub-Category": ["Sub-Category 1", "Sub-Category 2", "Sub-Category 3"],
    Display: ["Current", "Non-Current", "All"],
  };

  return (
    <>
      <PageMeta
        title="Products"
        description="This is Products Page"
      />
      <div className="space-y-6">
        <ComponentCard title="Products">
          <div className="overflow-hidden rounded-xl bg-white dark:bg-white/[0.03]">
            <div className="flex flex-col gap-2 px-4 py-4 border border-b-0 border-gray-100 dark:border-white/[0.05] rounded-t-xl sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">Products</div>
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                <div className="relative">
                  <FilterDropDown
                    selectedFilters={selectedFilters}
                    setSelectedFilters={setSelectedFilters}
                  />
                </div>
                <Button
                  className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]"
                  size="sm"
                  onClick={() => navigate("/add-new-product")}
                >
                  Add New product
                </Button>
              </div>
            </div>
            <div className="flex flex-col gap-2 px-4 py-4 border border-b-0 border-gray-100 dark:border-white/[0.05] rounded-t-xl sm:flex-row">
              <div className="flex flex-wrap gap-2">
                {selectedFilters.map((filter) => (
                  <div
                    key={filter}
                    className="flex items-center space-x-2 bg-gray-100 p-2 rounded-md"
                  >
                    <label className="text-sm font-medium capitalize">{filter}:</label>
                    {searchOptions.includes(filter) ? (
                      selectOptions[filter as keyof typeof selectOptions] ? (
                        <Select
                          options={selectOptions[filter as keyof typeof selectOptions].map((option) => ({
                            value: option,
                            label: option,
                          }))}
                          onChange={(value) => handleSelectFilterChange(filter, value)}
                        />
                      ) : (
                        <input
                          type="text"
                          className="border p-1 rounded-md w-40"
                          onChange={(e) => handleTextFilterChange(filter, e.target.value)}
                        />
                      )
                    ) : checkboxOptions.includes(filter) ? (
                      <div className="flex space-x-2">
                        <Switch
                          label=""
                          defaultChecked={true}
                          onChange={() => handleCheckboxFilterChange(filter, "Yes")}
                        />
                      </div>
                    ) : null}
                    <button
                      className="text-gray-500 hover:text-red-600"
                      onClick={() => removeFilter(filter)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <ProductTable />
          </div>
        </ComponentCard>
      </div>
    </>
  );
};

export default Products;